import React from 'react';
import { Coins } from 'lucide-react';

interface CoinWidgetProps {
  onClick: () => void;
}

interface BonusOffer {
  id: string;
  name: string;
  price: number;
  features: {
    spins?: number;
    multiplier?: number;
    duration?: number;
  };
  description: string;
}

const CoinWidget: React.FC<CoinWidgetProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="group relative w-16 h-16 bg-yellow-400 rounded-full shadow-lg
        hover:scale-110 transition-all duration-300 ease-in-out
        animate-bounce hover:animate-none
        flex items-center justify-center
        hover:bg-yellow-300 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
    >
      <Coins className="w-8 h-8 text-yellow-900 group-hover:scale-110 transition-transform" />
      
      {/* Pulsing ring effect */}
      <div className="absolute inset-0 rounded-full bg-yellow-400/30
        animate-ping group-hover:animate-none"></div>

      {/* Floating tooltip */}
      <div className="absolute -top-2 -translate-y-full bg-black/75 text-white text-xs
        px-2 py-1 rounded whitespace-nowrap opacity-0 group-hover:opacity-100
        transition-opacity pointer-events-none">
        Special Offers!
      </div>
    </button>
  );
};

export default CoinWidget;